import i18n from 'i18next';
import LanguageDetector from 'i18next-capacitor-language-detector';
import { initReactI18next } from 'react-i18next';

import { LanguageItems } from '@type';

import ar from './locales/ar.json';
import de from './locales/de.json';
import en from './locales/en.json';
import fr from './locales/fr.json';
import it from './locales/it.json';
import pt from './locales/pt.json';

export const defaultNS = LanguageItems.English.code;
const initialLan = navigator.language || defaultNS;

void i18n
  .use(initReactI18next)
  .use(LanguageDetector(initialLan))
  .init({
    lowerCaseLng: true,
    interpolation: {
      escapeValue: false,
    },
    resources: {
      en: { translation: en },
      de: { translation: de },
      fr: { translation: fr },
      pt: { translation: pt },
      ar: { translation: ar },
      it: { translation: it },
    },
  });

export default i18n;
